import { Injectable } from '@angular/core';
 
@Injectable({
  providedIn: 'root'
})
export class ElasticAPMGuidService {
  private sessionGuid: string = '';
 
  constructor() {}
 
  generateGUID() {
    this.sessionGuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
 
  getSessionGuid(): string {
    this.generateGUID();
    return this.sessionGuid;
  }
}